import { FullStory, init, isInitialized } from '@fullstory/browser';

export const fullStoryEnvironments = ['production', 'staging'];

export const isFullStoryAllowed = fullStoryEnvironments.includes(
  process.env.ENVIRONMENT_NAME!,
);

export const shutdownFullStory = () => {
  if (isInitialized()) {
    FullStory('shutdown');
  }
};

export const startFullStory = () => {
  if (isInitialized()) {
    FullStory('restart');
  } else {
    init({ orgId: process.env.FULLSTORY_ORG_ID, devMode: !isFullStoryAllowed });
  }
};
